import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 6l-7 12","key":"svg-0"}],["path",{"d":"M20 6l-7 12","key":"svg-1"}],["path",{"d":"M5 14v.015","key":"svg-2"}],["path",{"d":"M5 10.015v.015","key":"svg-3"}]]

const IconProtocol = createReactComponent('outline', 'protocol', 'Protocol', __iconNode);

export default IconProtocol;